<div class="stake-limit-header">
    <div class="monthly-stake">
        <span class="monthly-stake-title">{{ messages.common.MonthlyStakeLimit }}</span>
        <span class="theme-info betslip-summary__wins__info-icon" (click)="showMonthlyStakeInfoHelp()"></span>
    </div>
    <div class="days-remaining" *ngIf="warnUserAboutRemainingBalance">{{ daysRemaining }} {{ messages.common.MonthlyStakeLimitDaysRemaining }}</div>
</div>

<bs-user-stake-limit-info *ngIf="monthlyStakeInfoHelp" (close)="closeMonthlyStakeInfoHelp()"></bs-user-stake-limit-info>

<ng-container *ngIf="warnUserAboutRemainingBalance">
    <bs-stake-progress-bar [stakeProgressBarContext]="stakeProgressBarContext" [currencySymbol]="currencySymbol"></bs-stake-progress-bar>
    <div class="link-change-stake pc-txt" [innerHtml]="messages.common.ViewChangeMonthlyStakeLimit | msTrust: 'html'"></div>
</ng-container>
